import HomeView from './HomeView'

export const HomeContainer = () => <HomeView title="Home" />
